import InfiniteScroll from "react-infinite-scroll-component";

import { Columnizer } from "components/blocks/Columnizer";
import { FollowingItem } from "components/following/FollowingItem";
import { IUser } from "services/types";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TABLET_WIDTH } from "hooks/useDeviceType";
import "./styles/Following.scss";

interface IFollowingProps {
  handleFollow: (id: string) => void;
  following: string[];
  users: IUser[];
  total: number;
  hasMore: boolean;
  fetchMore: () => void;
}

// eslint-disable-next-line no-magic-numbers
const SIZES = [450];

export const Following = (props: IFollowingProps) => {
  const {
    handleFollow,
    following,
    users
  } = props;
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  const fetchMore = () => {
    props.fetchMore();
  };

  return (
    <div className="Following">
      <InfiniteScroll
        dataLength={users.length}
        hasMore={props.hasMore}
        next={fetchMore}
        loader={<></>}
        scrollableTarget={!isDesktop ? "scrollableDiv" : undefined}
      >
        <Columnizer sizes={SIZES}>
          {users.map((user: IUser) => (
            <FollowingItem
              key={user.username}
              user={user}
              followed={following.indexOf(user.username) >= 0}
              onFollow={handleFollow}
            />
          ))}
        </Columnizer>
      </InfiniteScroll>
    </div>
  );
};
